import { render } from "./MoreMenu.vue?vue&type=template&id=c0568860&scoped=true"
import script from "./MoreMenu.vue?vue&type=script&lang=js"
export * from "./MoreMenu.vue?vue&type=script&lang=js"

import "./MoreMenu.vue?vue&type=style&index=0&id=c0568860&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0568860"]])

export default __exports__